// extracted by mini-css-extract-plugin
export default {"Matomo":"Matomo_Matomo__wBo-W"};